import { X } from 'lucide-react';
import type { PendingUpload } from '../../hooks/useImageUpload';

interface AttachmentStripProps {
  uploads: PendingUpload[];
  onRemove: (id: string) => void;
}

export function AttachmentStrip({ uploads, onRemove }: AttachmentStripProps) {
  if (uploads.length === 0) return null;

  return (
    <div className="flex gap-2 overflow-x-auto border-t border-fog bg-ivory px-3 py-2">
      {uploads.map((upload) => {
        const inProgress =
          upload.status === 'resizing' ||
          upload.status === 'presigning' ||
          upload.status === 'uploading';
        const failed = upload.status === 'error';

        return (
          <div
            key={upload.id}
            className="relative h-16 w-16 flex-shrink-0"
          >
            <img
              src={upload.thumbnailUrl}
              alt=""
              className="h-full w-full rounded-lg border border-fog object-cover"
            />

            {inProgress && (
              <div className="absolute inset-0 flex items-center justify-center rounded-lg bg-espresso/50 text-[10px] font-medium text-ivory">
                {upload.progress}%
              </div>
            )}

            {failed && (
              <div
                className="absolute inset-0 flex items-center justify-center rounded-lg bg-red-600/60 text-[10px] font-medium text-ivory"
                title={upload.error ?? 'Upload failed'}
              >
                !
              </div>
            )}

            <button
              type="button"
              onClick={() => onRemove(upload.id)}
              className="absolute -right-1.5 -top-1.5 flex h-5 w-5 items-center justify-center rounded-full bg-espresso text-ivory shadow"
              aria-label="Remove image"
            >
              <X className="h-3 w-3" />
            </button>
          </div>
        );
      })}
    </div>
  );
}
